/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React from 'react';
import { Alert } from 'react-bootstrap';
import * as S from './styles';

export interface IOfferProps {
  image?: string;
  description?: string;
}

export const OfferComponent = (props: IOfferProps) => {
  const { description, image } = props;
  const _getDescription = () => {
    if (Array.isArray(description) && description?.length > 0) {
      return (
        <>
          {description?.map((ele, index) => {
            if (index < description?.length - 1) {
              return (
                <span className="pb-4" key={`${index}`}>
                  {ele} <br /> <br />
                </span>
              );
            } else {
              return (
                <span className="pb-4" key={`${index}`}>
                  {ele} <br />
                </span>
              );
            }
          })}
        </>
      );
    } else {
      return description;
    }
  };
  return (
    <>
      <img src={image} alt="Offer" weight={'100%'} height={'auto'} />
      <S.OfferHeading className="pt-3 pb-2">
        <Alert variant="success">{_getDescription()}</Alert>
      </S.OfferHeading>
    </>
  );
};
